import request from './base'
export const taskList = (params) => {
    return request.post("/admin/v1/task/list", params)
}
export const taskInfo = (params) => {
    return request.post("/admin/v1/task/info", params)
}


// WEBPACK FOOTER //
// ./src/api/task.js